import { render, staticRenderFns } from "./conta-bancaria-pesquisa.vue?vue&type=template&id=2623e321&scoped=true&"
import script from "./conta-bancaria-pesquisa.vue?vue&type=script&lang=js&"
export * from "./conta-bancaria-pesquisa.vue?vue&type=script&lang=js&"
import style0 from "./conta-bancaria-pesquisa.vue?vue&type=style&index=0&id=2623e321&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2623e321",
  null
  
)

export default component.exports